module.exports = __webpack_public_path__ + "static/img/5556_phase_function_Paper_Points.2b8c197.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5556_phase_function_Paper_Points.png
// module id = RrBv
// module chunks = 0